module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAAHgAAAAD4behcAAAA9klEQVRIDWNgYGCwAuL/VMKVLECDYOADkPEMxiGR5geqlwbpQTZwDZCfChIkA8QA9SwG6WMiQzNeLcguVAKqDMWrGrekOUwK2UAnoCAIUwSQDTwHNGkzmabpAfUFgvSiG9gAEiQDgCIFbCDVI2XUQDKiA03LaBiiBQgZ3NEwJCPQ0LQM/jBELg+dga5fheYDYrnyMIXIBioCBUGYIoBs4D6gSTOwmFYFFDOAiv8C0qDSGR3YAQVyYIKwlsNsmAAavQ3Ih7UsvqLJwbggS0BqUFoOMEl0OgMowAMVBGnCC5C9HAJUCXItOQDUFAEDZAMFgCIgTBEAABlYKv6LKyKNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/images/Phone.png
// module id = 2398
// module chunks = 0